export default __webpack_public_path__ + "static/banner01-7afcfacf4476d3385764ebc500270a20.png";